module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper work"
  }, [_c('h1', {
    staticClass: "work__page-title"
  }, [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), (_vm.document.native_video_mp4) ? _c('section', {
    staticClass: "work__showreel"
  }, [_c('video', {
    attrs: {
      "playsinline": "true",
      "autoplay": "true",
      "muted": "true",
      "loop": "true",
      "poster": _vm.document.native_video_fallback_image.sizes.large
    }
  }, [(_vm.document.native_video_webm) ? _c('source', {
    attrs: {
      "src": _vm.document.native_video_webm.url,
      "type": "video/webm"
    }
  }) : _vm._e(), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.document.native_video_mp4.url,
      "type": "video/mp4"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_c('c-project-list', {
    attrs: {
      "filter": "all",
      "padded": "true"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8c5c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
// module id = 275
// module chunks = 0